import { getTransporterApiBaseUrl } from "./api-base";

export type AdminTransporterOption = {
  id: string;
  legalName: string;
  dbaName: string | null;
};

type AdminTransportersResponse = {
  transporters: AdminTransporterOption[];
};

/**
 * **`GET /api/v1/admin/transporters`** — **`platform_admin`** only. Used to scope the transporter workspace
 * without pasting UUIDs.
 */
export async function fetchAdminTransporters(
  getToken: () => Promise<string | null>,
): Promise<AdminTransporterOption[]> {
  const token = await getToken();
  if (!token) {
    throw new Error("not_signed_in");
  }
  const base = getTransporterApiBaseUrl();
  const path = "/api/v1/admin/transporters?limit=200&offset=0";
  const url = base ? `${base}${path}` : path;
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (res.status === 403) {
    throw new Error("forbidden");
  }
  if (!res.ok) {
    throw new Error(`admin_transporters_http_${res.status}`);
  }
  const body = (await res.json()) as AdminTransportersResponse;
  return body.transporters ?? [];
}
